import { render, staticRenderFns } from "./ContainerLoadingInfoComponent.vue?vue&type=template&id=2965b4ac&scoped=true"
import script from "./ContainerLoadingInfoComponent.vue?vue&type=script&lang=ts"
export * from "./ContainerLoadingInfoComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965b4ac",
  null
  
)

export default component.exports